module.exports = __webpack_public_path__ + "static/media/ic_entry_exit.4158bf57.png";